import {isMobile} from '../../util/panelbankFlow';
import {DEFAULT_MOBILE_PANELS_PER_PAGE} from '../../util/sectionFlowConfig';

export type PageSizeOption = number | 'all';

const MULTIPLIER = 2;
const MAX_OPTIONS = 6;
export const MAX_SECTION_PAGE_SIZE = 50;

export const getFlowConfigPageSizeOptions = ({
  columnsPerPage,
  numTotalPanelsInSection,
}: {
  columnsPerPage: number;
  numTotalPanelsInSection: number;
}): PageSizeOption[] => {
  const columnCount = isMobile()
    ? DEFAULT_MOBILE_PANELS_PER_PAGE
    : columnsPerPage;

  const options: PageSizeOption[] = [columnCount];

  let nextSize = columnCount * MULTIPLIER;
  while (
    nextSize < numTotalPanelsInSection &&
    nextSize <= MAX_SECTION_PAGE_SIZE &&
    options.length < MAX_OPTIONS
  ) {
    options.push(nextSize);
    nextSize *= MULTIPLIER;
  }

  if (numTotalPanelsInSection <= MAX_SECTION_PAGE_SIZE) {
    options.push('all');
  }

  return options;
};

export const getFlowConfigMaxRowsPerPage = ({
  columnsPerPage,
  numTotalPanelsInSection,
  option,
}: {
  columnsPerPage: number;
  numTotalPanelsInSection: number;
  option: number | 'all';
}) => {
  const totalPanels = Math.min(
    numTotalPanelsInSection,
    option === 'all' ? numTotalPanelsInSection : option
  );

  return Math.ceil(totalPanels / columnsPerPage);
};
